import { PLAY_URL } from 'config';

export const PLAY_PODCAST_PAGE_ROOT_URL = `${PLAY_URL}/podcast-details`;
